import React, { useState } from "react";
import useAxios from "../../../../MainComponents/Hooks/useAxios";
import { DatePicker, Spin } from "antd";
import { CSVLink } from "react-csv";

const { RangePicker } = DatePicker;

const PaymobOrders = () => {
  const [date, setDate] = useState([]);
  const [status, setStatus] = useState("all");

  const [getOrdersSuccess, getOrdersErrors, getOrdersLoading] = useAxios(
    process.env.REACT_APP_ADMIN_ORDERS_API,
    "GET",
    date?.length === 2,
    date,
    status !== "all"
      ? {
          date_from: date[0],
          date_to: date[1],
          status: status,
        }
      : { date_from: date[0], date_to: date[1] },
    false,
    status
  );

  const handleChangeDate = (dates) => {
    setDate(dates);
  };

  return (
    <div className="mb-20 flex flex-col items-start gap-10">
      <h3 className="w-full text-3xl font-bold md:text-center">Paymob</h3>

      <div className=" w-1/2 sm:w-full">
        <RangePicker
          className="signin-inputs"
          onChange={(_, dateString) => handleChangeDate(dateString)}
        />
      </div>
      <div className=" w-1/2 sm:w-full">
        <p>Status</p>
        <select
          className="signin-inputs !w-fit"
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="all">All</option>
          <option value="pending">Pending</option>
          <option value="success">Success</option>
        </select>
      </div>

      {getOrdersSuccess?.data && (
        <button className="w-fit rounded-2xl border-2 border-accent bg-accent px-3 py-1 text-center font-semibold text-light duration-300 hover:bg-light hover:text-accent active:scale-90">
          <CSVLink
            data={getOrdersSuccess?.data}
            filename={`Transaction Excel.csv`}
          >
            Export
          </CSVLink>
        </button>
      )}

      <ul
        className={` flex gap-4 min-h-[300px] w-full ${
          getOrdersSuccess?.data ? "opacity-100 " : "opacity-0"
        } transition-all duration-500 ease-in-out`}
      >
        <li className="flex-1 border-2 border-secondary rounded-xl p-4 overflow-x-scroll">
          Total Amount:{" "}
          <span className="font-bold text-[red]">
            {getOrdersSuccess?.data?.reduce(
              (total, order) => total + Number(order.amount),
              0
            )}{" "}
            EGP
          </span>
          {getOrdersLoading ? (
            <div className="w-full h-full flex items-center justify-center">
              <Spin size="large" />
            </div>
          ) : (
            getOrdersSuccess?.data?.map((wallet) => (
              <ul className="flex items-center justify-between mt-10 mb-5 !whitespace-nowrap gap-10">
                <li>
                  <span className="font-bold">Name:</span> {wallet?.student}
                </li>

                <li>
                  <span className="font-bold">Lecture:</span> {wallet?.lecture}{" "}
                </li>
                <li>
                  <span className="font-bold">Discount:</span>{" "}
                  {wallet?.discount}%
                </li>

                <li>
                  <span className="font-bold">Amount:</span> {wallet?.amount}{" "}
                  EGP
                </li>

                <li>
                  <span className="font-bold">Payment Status:</span>{" "}
                  {wallet?.payment_status}
                </li>
              </ul>
            ))
          )}
        </li>
      </ul>
    </div>
  );
};

export default PaymobOrders;
